// Needs to be fixed
// We should be using fabric types here

export enum GradientType {
  Linear = 'linear',
  Radial = 'radial',
}

export enum GradientUnits {
  Pixels = 'pixels', // Unused
  Percentage = 'percentage',
}

/**
 * Utility type for a gradient stop
 */
export interface GradientColorStop {
  color: string;
  offset: number;
  opacity?: number;
}

/**
 * A general color type
 */
export type Color = GradientObject | string | null | undefined;

/**
 * RGBA Color object
 */
export interface RGBAColorObject {
  r: number;
  g: number;
  b: number;
  a: number;
}

export interface GradientObject {
  id?: string;
  key?: string;
  colorStops: GradientColorStop[];
  coords?: {
    x1: number;
    x2: number;
    y1: number;
    y2: number;
    r1?: number;
    r2?: number;
  };
  type: GradientType;
  angle: number;
  /**
   * Doesn't contain angle information, angle is coming in angle property
   */
  gradientTransform?: number[];
}
